import { useStore } from '../../data/store';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function About() {
  const event = useStore((s) => s.event);
  const [ref, isVisible] = useScrollAnimation();

  const stats = [
    { value: '500+', label: 'Besucher pro Jahr' },
    { value: '2015', label: 'Gründungsjahr' },
    { value: '100%', label: 'Kostenloser Eintritt' },
  ];

  return (
    <section id="about" className="bg-bg-secondary section-padding">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="relative overflow-hidden">
            <img
              src="https://miz.org/sites/default/files/styles/sliderimage_desktop/public/externals/9646334b57101e1e0285e8d1a2b20706.jpg?itok=-jMx4zuk"
              alt="Rock'n'Rhein Festival Impression"
              className="w-full object-cover object-top h-[260px] md:h-[500px]"
              style={{ filter: 'saturate(0.8)' }}
              loading="lazy"
            />
            <div className="absolute inset-0 bg-accent-red/15 mix-blend-multiply" />
          </div>

          <div className="px-2 md:px-0">
            <p className="font-heading text-accent-red text-sm tracking-[4px] mb-4">SEIT 2015</p>
            <h2 className="font-heading text-text-primary mb-8" style={{ fontSize: 'clamp(28px, 7vw, 48px)' }}>
              ROCK AM RHEIN — MEHR ALS EIN FESTIVAL
            </h2>
            <p className="font-body text-text-muted leading-relaxed text-base md:text-lg mb-6">{event?.about1}</p>
            <p className="font-body text-text-muted leading-relaxed text-base md:text-lg">{event?.about2}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-16 md:mt-20 pt-12 md:pt-16 border-t border-divider">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-4xl md:text-5xl text-accent-red mb-3">{stat.value}</div>
              <div className="font-body text-text-muted text-sm md:text-base">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}
